var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 32,
    viewBox: "0 0 45 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 32,
    fill: "url(#pattern0_30_14)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_30_14",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_30_14",
    transform: "matrix(0.00555556 0 0 0.0078125 0.144444 0)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_30_14",
    width: 128,
    height: 128,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAQAAABpN6lAAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAHdElNRQfhCxECBQoQn6pZAAABx0lEQVR42u3ZuXITQRRG4WPkKmc2++LAUASOeUxynkE4J+QBxI5ZDS6eglhUDUFTLiPZMkbT03e6z6dct/+TDkiSJEmSJEmSJEmSJEmSJCWbbJR+wko77OV74X2e84ufPGZSeueZJjxhTscxj/IceEv35zcNmGDC9OR9P7jS/4GHJ38fMcHp+R0d+/2fePDXgVgJFud37OY4MwuaYHn+szyHdjkOmGB5/oztXMeWEzwtnGDQ+fESDD4f4B7fgyQoMj8l+BYgQbH5MRIUnQ9wl6OCCYrPL5sgxPyU4GuBBGHmA9wZPEGo+cMnCDc/JfgyUIKQ8wFuD5Ig7PyU4HPmBKHn508Qfj7ALT5lSjCK+fkSjGZ+SvCx5wSjmg9ws9cEo5ufEnzoKcEo5/eXYLTzU4LDNROMej7AjbUSjH7+egmqmA9wnff/kaCa+SnBu0smqGr+5RNUNx/g2qnP6qsTVDn/3xNUOz8leHNBgqrnX5yg+vkAV3l9ToIm5p+foJn5KcGrhbHTluafnaCp+QA7vGx5/qoEjcxPCV60PB9geyFBY/NTglnL81OCA+bMOWhzfrLFVuknSJIkSZIkSZIkSZIkSZKkWv0GN8vEwih44+EAAAAuelRYdGRhdGU6Y3JlYXRlAAB42jMyMDTXNTTUNTQPMTCyMjC1MjTQNjCwMjAAAEFhBQT/cRaSAAAALnpUWHRkYXRlOm1vZGlmeQAAeNozMjA01zU01DU0DzEwsjIwtTI00DYwsDIwAABBYQUE1k6+GgAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/Down.b9bdf0c11fc876943dec03b390ff4d62.svg";
export { ForwardRef as ReactComponent };